
import { Component, Prop, Vue } from 'vue-property-decorator';

import Icon from '@/components/UI/Icon.vue';
import LookupWarehouses from '@/components/UI/LookupWarehouses.vue';

import { kktsSplitToBase } from '@/utils/PortalConstants';
import { fetchJobUnlock, fetchSetJobEditStatusSplitToBase, fetchSetJobLock } from '@/helpers/fetchers';

import { JobComplianceData } from '@/models/JobComplianceTypes';
import { JobLockError, ValidationAPIError } from '@/helpers/throwables';
import { notifyNetworkError } from '@/helpers/notifiers';

@Component({
  components: {
    Icon,
    LookupWarehouses,
  },
})
export default class SplitToBase extends Vue {
  @Prop({ type: Object, required: false, default: false }) public formData: JobComplianceData;

  public loading = false;
  public kktsSplitToBase = kktsSplitToBase;
  public split_stop_number = 2;
  public split_base = 1;

  public splitToBaseRadioClicked(stop_number: number): void {
    this.split_stop_number = stop_number;
  }

  public splitToBaseChanged(warehouse: string): void {
    this.split_base = kktsSplitToBase.indexOf(warehouse) + 1;
  }

  public async setJobSplitToBase(): Promise<void> {
    this.loading = true;
    const params = {
      action: 'tobase',
      driver: this.formData.driver_code || 0,
      base: this.split_base,
      stop_number: this.split_stop_number,
    };

    await fetchSetJobLock(this.formData.rockhopper_id, this.formData.rockhopper_date)
      .then(async () => {
        await fetchSetJobEditStatusSplitToBase(this.formData.rockhopper_id, this.formData.rockhopper_date, params)
          .then(() => {
            this.$emit('fetchData');
          })
          .catch(err => {
            // In case of validation error, unlock the job
            if (err instanceof ValidationAPIError) {
              console.debug('ValidationAPIError', err);
              notifyNetworkError({ text: err.message });
            }
          })
          .finally(async () => {
            await fetchJobUnlock(this.formData.rockhopper_id, this.formData.rockhopper_date);
          });
      })
      .catch(err => {
        if (err instanceof JobLockError) {
          return;
        }
      });

    this.loading = false;
  }
}
